import { clsx } from 'clsx';

type TTableProps = {
  columns: {
    field: string;
    headerName: string;
  }[];
  rows: {
    id: number;
    [key: string]: string | number;
  }[];
};

const tableBorderClassname = ' border-solid border-base-dark';

export const Table: React.FC<React.PropsWithChildren<TTableProps>> = ({
  columns,
  rows,
}) => {
  return (
    <table className={clsx(tableBorderClassname, 'mb-16')}>
      <thead>
        <tr>
          {columns.map(column => (
            <th
              key={column.field}
              className={clsx(tableBorderClassname, 'border-2 p-8')}
            >
              {column.headerName}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map(row => (
          <tr key={row.id}>
            {columns.map(column => {
              let value = row[column.field];

              if (!value && process.env.NODE_ENV === 'development') {
                console.warn(
                  `The row: "${JSON.stringify(
                    row,
                  )}" doesn't contains the value ${column.field}`,
                );
                value = 'not-defined';
              }

              return (
                <td
                  key={value}
                  className={clsx(tableBorderClassname, 'border p-8')}
                  dangerouslySetInnerHTML={{
                    __html: value.toString(),
                  }}
                />
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
